import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbService } from "../../services/db/db.service";
import { UtilService } from '../../services/utils/util.service';
import { Blog } from '../../model/blog.model';

@Component({
  selector: 'app-home',
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {

  downloads = {
    android: "10K+",
    ios: "9K+",
    windows: "7K+",
    macos: "8K+",
  };

  blogs: Blog[] = [];

  getDateTime(input: any){
    return this.util.getFormatedDateTime(input);
  }

  constructor(private db: DbService, private util: UtilService) { }

  ngOnInit(): void {
    this.fetchBlogs();
    this.fetchDownloads();
  }

  ngOnDestroy(): void {
    
  }

  fetchBlogs(){
    this.db.getBlogsData().subscribe((result) => {
      console.log(result);
      if (result.status_code === 1) {
        this.blogs = result.data;
      }
    });
  }

  fetchDownloads(){
    this.db.getInfoData().subscribe((result) => {
      console.log(result);
      if (result.status_code === 1) {
        this.downloads.android = this.util.formatDownloadCount(result.data[0].android_download);
        this.downloads.ios = this.util.formatDownloadCount(result.data[0].ios_download);
        this.downloads.windows = this.util.formatDownloadCount(result.data[0].win_download);
        this.downloads.macos = this.util.formatDownloadCount(result.data[0].mac_download);
      }
    });
  }

  showFullContent(index:number){
    this.blogs[index].is_expanded = !this.blogs[index].is_expanded;
  }
}
